var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex1"},[(!_vm.isEdit)?_c('p',{staticClass:"flex1 remark-text",style:(`${_vm.item.content ? '' : 'color:#aaa;'}`),on:{"click":_vm.edit}},[_vm._v(_vm._s(_vm.item.content || 'Deleted Response'))]):_c('recordText',{attrs:{"item":_vm.item,"onSend":_vm.onSendFn,"defaultText":_vm.item.content,"cancel":_vm.cancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }